module.exports = __webpack_public_path__ + "static/media/service_happy-hour.e8211c4c.jpg";